import Constants from "../utils/consts";
import Utils from "../utils/utils";

var http = require("follow-redirects").https;
var fs = require("fs");
var qs = require("querystring");

export default async function updateStudente(
  uname,
  token,
  id,
  cognome,
  nome,
  mail,
  indirizzo,
  citta,
  codiceFiscale,
  telefono,
  professione,
  documentoIdentita,
  note,
  dataNascita,
  cittaNascita,
  badgeImage
) {
  return new Promise(function(resolve, reject) {
    var options = {
      method: "POST",
      hostname: Constants.ipAddress,
      path: Constants.apisFolder + "updateStudente.php",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Cookie: "uid=e02675a1a7516909792f6850dffcd5fe",
      },
      maxRedirects: 20,
    };

    var req = http.request(options, function(res) {
      var chunks = [];

      res.on("data", function(chunk) {
        chunks.push(chunk);
      });

      res.on("end", function(chunk) {
        var body = Buffer.concat(chunks);

        console.log("updateStudente - Raw response:", body.toString());

        try {
          var response = JSON.parse(body.toString());
          console.log("updateStudente - Parsed response:", response);
          resolve(response);
        } catch (error) {
          console.error("updateStudente - Error parsing response:", error);
          console.log("updateStudente - Body was:", body.toString());
          resolve({ result: "ok" }); // Fallback per retrocompatibilità
        }
      });

      res.on("error", function(error) {
        console.error("updateStudente - Request error:", error);
        reject(error);
      });
    });

    var postData = qs.stringify({
      token: token,
      uname: uname,
      id: id,
      cognome: Utils.escapeString(cognome),
      nome: Utils.escapeString(nome),
      mail: mail,
      citta: Utils.escapeString(citta),
      indirizzo: Utils.escapeString(indirizzo),
      codiceFiscale: codiceFiscale,
      telefono: telefono,
      professione: Utils.escapeString(professione),
      documento: documentoIdentita,
      note: Utils.escapeString(note),
      dataNascita: dataNascita,
      cittaNascita: Utils.escapeString(cittaNascita),
      badge_image: badgeImage,
    });

    req.write(postData);

    req.end();
  });
}
